import { render, staticRenderFns } from "./BestsellersProduct.vue?vue&type=template&id=3824687e"
import script from "./BestsellersProduct.vue?vue&type=script&lang=js"
export * from "./BestsellersProduct.vue?vue&type=script&lang=js"
import style0 from "./BestsellersProduct.vue?vue&type=style&index=0&id=3824687e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports